const isLocalStorageSupported = () => {
  try {
    const key = 'is-local-storage-supported';
    global.localStorage.setItem(key, true);
    global.localStorage.removeItem(key);
    return true;
  } catch {
    return false;
  }
};

export const createShim = () => {
  const store = {
    setItem(id, val) {
      return (store[id] = String(val));
    },
    getItem(id) {
      return Object.hasOwn(store, id) ? String(store[id]) : null;
    },
    removeItem(id) {
      return delete store[id];
    },
    clear() {
      throw new Error('Not implemented!');
    },
  };

  return store;
};

const supported = isLocalStorageSupported();

export const localStorage = supported ? global.localStorage : createShim();
export const sessionStorage = supported ? global.sessionStorage : createShim();
